import { FOOTFALL_AREA_ACTIVE_STATUS, NAME, STORES } from '../../fields'

export const transformValuesToBE = values => {
  return {
    [NAME]: values[NAME],
    [STORES]: values[STORES]?.map(store => store.value),
    status: FOOTFALL_AREA_ACTIVE_STATUS
  }
}
